import { Theme } from '@mui/material';

const Dialog = (theme: Theme) => {
  return {
  };
};

export default Dialog;
